import download from 'downloadjs';

import request from 'utils/request';
import { keysToSnakeCaseDeep } from 'utils/stringUtils';

export default {
  create: async (groupId, data) => {
    // need to convert everything but properties to snake case then ignoreSnakeCaseConversion later
    const { properties, ...rest } = data;
    const snakeCaseData = keysToSnakeCaseDeep(rest);
    snakeCaseData['properties'] = properties;

    const response = await request.post(
      `/suppliers/${groupId}/purchased_components/`,
      snakeCaseData,
      { ignoreSnakeCaseConversion: true },
    );
    return response;
  },

  delete: async (purchasedComponentId) => {
    await request.delete(
      `/suppliers/purchased_components/${purchasedComponentId}`,
    );
  },
  get: async (purchasedComponentId) => {
    const response = await request.get(
      `/suppliers/purchased_components/${purchasedComponentId}`,
    );
    return response;
  },
  list: async (groupId, params) => {
    const response = await request.get(
      `/suppliers/${groupId}/purchased_components/`,
      params,
    );
    return response;
  },
  update: async (purchasedComponentId, data) => {
    // need to convert everything but properties to snake case then ignoreSnakeCaseConversion later
    const { properties, ...rest } = data;
    const snakeCaseData = keysToSnakeCaseDeep(rest);
    snakeCaseData['properties'] = properties;

    const response = await request.patch(
      `/suppliers/purchased_components/${purchasedComponentId}`,
      snakeCaseData,
      { ignoreSnakeCaseConversion: true },
    );
    return response;
  },
  uploadCsv: async (groupId, data) => {
    const response = await request.post(
      `/suppliers/${groupId}/purchased_components_csv_upload`,
      data,
    );
    return response;
  },
  downloadCsv: async (groupId) => {
    const response = await request.post(
      `/suppliers/${groupId}/purchased_components_csv_download`,
    );
    const blob = new Blob([response], {
      type: 'text/plain',
    });
    download(blob, 'purchased-components.csv');
  },

  customColumns: {
    list: async (groupId) => {
      const response = await request.get(
        `/suppliers/${groupId}/purchased_component_columns`,
      );
      return response;
    },
    create: async (groupId, data) => {
      const response = await request.post(
        `/suppliers/${groupId}/purchased_component_columns`,
        data,
      );
      return response;
    },
    update: async (columnId, data) => {
      const response = await request.patch(
        `/suppliers/purchased_component_columns/${columnId}/`,
        data,
      );
      return response;
    },
    delete: async (columnId) => {
      const response = await request.delete(
        `/suppliers/purchased_component_columns/${columnId}/`,
      );
      return response;
    },
  },
};
